import { render, staticRenderFns } from "./CurrentCart.vue?vue&type=template&id=4f526ab7"
import script from "./CurrentCart.vue?vue&type=script&lang=ts"
export * from "./CurrentCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports